import React from 'react'

export default class Intro extends React.Component{
	constructor(props) {
		super(props)
		this.state = {
			age: '',
		}
	}

	onButtonClick = e => {
		const {setProperties, setScreenID} = this.props
		const {age} = this.state

		let currentClassList = e.currentTarget.classList
		currentClassList.add('button--active-reverse')

		const prename = document.getElementById('input1').value
		const lastname = document.getElementById('input2').value
		let name = prename + ' ' + lastname

		setTimeout(function(){ 
			setProperties('name', name)
			setProperties('age', age)
			setScreenID()
		}, 300)
	}

	onFlexbuttonClick = e => {
		//remove active from buttons
		let element = document.getElementsByClassName('flex-button--active')
		if(element[0]){
			element[0].classList.remove('flex-button--active')
		}
		//add active to current button
		e.currentTarget.classList.add('flex-button--active')
		let newAge = e.currentTarget.getAttribute('name')
		this.setState({
			age: newAge
		})
	}

	render(){
		const {
			data,
			setScreenID,
			setProperties
		} = this.props 

		let introData = data.intro
		let question = introData.text_1
		let line1 = introData.text_2
		let line2 = introData.text_3
		let optionsHeadline = introData.text_4
		let options = introData.options
		let button = introData.button
		let _this = this

		return(
			<div className='intro'>
				<div className='question'>{question}</div>
				<div className='form-container'>
					<input type="text" id='input1'/>
					<div className='form-text'>{line1}</div>
					<input type="text" id='input2'/>
					<div className='form-text'>{line2}</div>
				</div>
				<div className='options-container'>
					<div className='options-headline'>{optionsHeadline}</div>
					<div className='options'>
						{options.map(function(icon,index){
							let name = icon.field
							return (
								<div name={name} key={index} className='flex-button' onClick={_this.onFlexbuttonClick}>{name}</div>
							)
						})}
					</div>
				</div>
				<div className='button button--reverse' onClick={this.onButtonClick}>{button}</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/splitScreen/subcomponents/intro.js